/* GIF -> video swap. Markup is prepared server-side by snippets/gifv-rewrite.liquid. */
(function () {
  var script = document.currentScript;
  var base = script && script.src ? script.src.split('gifv.js')[0] : '';
  if (!base) return;
  // Asset URLs are unversioned; reuse gifv.js ?v= so re-encoded files bypass the CDN cache.
  var ver = (script.src.match(/[?&]v=(\w+)/) || [])[0] || '';
  if (ver) ver = '?' + ver.slice(1);
  var AV1 = 'video/mp4; codecs="av01.0.05M.08"';
  var URL_ATTRS = ['src', 'srcset', 'data-src', 'data-srcset', 'data-bgset', 'href'];
  var DROP = /^(data-(src|srcset|bgset|widths|sizes|aspectratio|parent-fit|object-fit|gifv.*)|src|srcset|sizes|loading|alt|title)$/i;
  var SUFFIX = /^(_(\d+x\d*|\{width\}x))*\.gif/i;

  function restore(el) {
    var o = el.getAttribute('data-gifv-o');
    var poster = 'gifv-' + el.getAttribute('data-gifv') + '.webp';
    URL_ATTRS.forEach(function (a) {
      var v = el.getAttribute(a);
      if (v && v.indexOf(poster) !== -1) el.setAttribute(a, o);
    });
    el.removeAttribute('data-gifv');
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.dataset.gifvLoaded) {
          v.dataset.gifvLoaded = '1';
          Array.prototype.forEach.call(v.querySelectorAll('source'), function (s) { s.src = s.dataset.src; });
          v.load();
        }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '200px 0px' }) : null;

  function swap(img) {
    var key = img.getAttribute('data-gifv');
    var name = img.getAttribute('data-gifv-n') || '';
    var o = img.getAttribute('data-gifv-o') || '';
    var picture = img.parentNode && img.parentNode.tagName === 'PICTURE' ? img.parentNode : null;
    var rest = o.slice(o.indexOf(name) + name.length);
    var size = /^_(\d+)x/.exec(rest);
    if (key && size && +size[1] < 200) {
      // Thumbnails keep the static poster instead of pulling the full video.
      img.removeAttribute('data-gifv');
      return;
    }
    if (!key || !SUFFIX.test(rest) || !io) {
      restore(img);
      if (picture) Array.prototype.forEach.call(picture.querySelectorAll('source[data-gifv]'), restore);
      return;
    }
    var v = makeVideo(key);
    Array.prototype.forEach.call(img.attributes, function (a) {
      if (!DROP.test(a.name)) v.setAttribute(a.name, a.value);
    });
    v.className = (img.className.replace(/\blazy(load|loaded|loading)\b/g, '') + ' gifv').trim();
    var w = +img.getAttribute('width'), h = +img.getAttribute('height');
    if (w && h) v.style.aspectRatio = w + ' / ' + h;
    var alt = img.getAttribute('alt');
    if (alt) v.setAttribute('aria-label', alt);
    (picture || img).replaceWith(v);
    io.observe(v);
  }

  function makeVideo(key) {
    var v = document.createElement('video');
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('loop', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('preload', 'none');
    v.setAttribute('poster', base + 'gifv-' + key + '.webp' + ver);
    [[key + '.av1.mp4', AV1], [key + '.mp4', 'video/mp4']].forEach(function (s) {
      var el = document.createElement('source');
      el.dataset.src = base + 'gifv-' + s[0] + ver;
      el.type = s[1];
      v.appendChild(el);
    });
    return v;
  }

  // Background-image GIFs (data-bgset containers): overlay a cover video; the poster stays as the bg.
  function swapBg(el) {
    var key = el.getAttribute('data-gifv');
    el.removeAttribute('data-gifv');
    if (!key || !io) return;
    var v = makeVideo(key);
    v.className = 'gifv gifv-bg';
    v.setAttribute('aria-hidden', 'true');
    if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
    el.appendChild(v);
    io.observe(v);
  }

  var BG = '[data-gifv][data-bgset]:not(img):not(source)';

  function scan(root) {
    Array.prototype.forEach.call(root.querySelectorAll(BG), swapBg);
    Array.prototype.forEach.call(root.querySelectorAll('a[data-gifv]'), restore);
    Array.prototype.forEach.call(root.querySelectorAll('img[data-gifv]'), swap);
  }

  scan(document);
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1 || !n.matches) return;
          if (n.matches('img[data-gifv]')) swap(n);
          else if (n.matches(BG)) swapBg(n);
          else scan(n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
